var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationsFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58179 10.5C3.58179 11.3438 4.20714 12 5.01117 12C5.79286 12 6.44054 11.3438 6.44054 10.5H3.58179Z",
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58461 4.35938C8.58461 6.58594 9.05362 7.24219 9.67897 7.85156C9.99165 8.17969 10.081 8.64844 9.92465 9.07031C9.76831 9.49219 9.3663 9.75 8.94195 9.75H1.08038C0.633702 9.75 0.231689 9.49219 0.0753514 9.07031C-0.0809866 8.64844 0.00834936 8.17969 0.321025 7.85156C0.946378 7.24219 1.41539 6.58594 1.41539 4.35938C1.41539 2.50781 2.84477 0.984375 4.65382 0.796875V0.375C4.65382 0.1875 4.81016 0 5.01117 0C5.18984 0 5.36851 0.1875 5.36851 0.375V0.796875C7.15523 0.984375 8.58461 2.50781 8.58461 4.35938Z",
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsFilled);
export default __webpack_public_path__ + "static/media/notifications-filled.48c5a5e6282894c479273d2ab1dc62c6.svg";
export { ForwardRef as ReactComponent };